import type { Bridge } from '../../contracts/bridge';
import type { SurfaceModelOutput } from '../../contracts/modeling';
import type { RiskTier } from '../../contracts/risk';
import type { MitigationPlan } from '../../contracts/mitigation';
import { OverviewPanel } from '../panels/OverviewPanel';
import { ForecastPanel } from '../panels/ForecastPanel';
import { RiskPanel } from '../panels/RiskPanel';
import { MitigationPanel } from '../panels/MitigationPanel';

interface BentoLayoutProps {
  bridge: Bridge | null;
  forecast: SurfaceModelOutput[];
  currentRisk: RiskTier | null;
  mitigation: MitigationPlan | null;
}

export function BentoLayout({
  bridge,
  forecast,
  currentRisk,
  mitigation,
}: BentoLayoutProps) {
  if (!bridge) {
    return (
      <div className="bento-grid">
        <div className="bento-cell bento-cell--full flex items-center justify-center">
          <div className="text-secondary">
            Select a bridge from the sidebar to view forecast data
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bento-grid">
      <div className="bento-cell bento-cell--md">
        <OverviewPanel bridge={bridge} />
      </div>
      <div className="bento-cell bento-cell--md">
        <RiskPanel bridge={bridge} currentRisk={currentRisk} />
      </div>
      <div className="bento-cell bento-cell--lg">
        <ForecastPanel bridge={bridge} forecast={forecast} />
      </div>
      <div className="bento-cell bento-cell--sm">
        <MitigationPanel bridge={bridge} mitigation={mitigation} />
      </div>
    </div>
  );
}
